import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload } from "actions"
import Title from "../general/title"
import _ from "lodash"
import { Line } from "react-chartjs-2"
import { defaults } from "react-chartjs-2"
import { graphOptions, graphTheme } from "../../graphTheme"
import currentUser from "helpers/currentUser"
import { toast } from "react-toastify"
import FullTable from "components/FullTable"
import settings from "settings"
import moment from "moment"
import helpers from "helpers/helpers"

import Modal from "react-responsive-modal"
import BustoutModal from "./modals/bustout"
import ContractModal from "./modals/contract"
import TransferModal from "./modals/transfer"
import ClosingModal from "./modals/closing"
import StartModal from "./modals/start"
import LotReservationModal from "./modals/lotReservation"
import CompleteModal from "./modals/complete"
import EstimatedModal from "./modals/estimated"
import ArcModal from "./modals/arcSubmitLot"
import OpenHouse from "./modals/openHouse"
import ArcViewApprovedLot from "./modals/arcViewApprovedLot"
import BuyerModal from "./modals/buyer"
import WebsiteInfoBuilders from "./modals/websiteInfoBuilders"
import PressingTable from "widgets/pressingTable"

_.merge(defaults, graphTheme)
// hide x axis labels
var opts = {
	scales: {
		xAxes: [
			{
				//display: false
			},
		],
	},
}
_.merge(graphOptions, opts)

class Dashboard extends Component {
	constructor(props) {
		super(props)
		this.state = {
			transferModal: false,
			startModal: false,
			completeModal: false,
			closingModal: false,
			estimatedModal: false,
			lotReservationModal: false,
			buyerModal: false,
			contractModal: false,
			websiteInfoModal: false,
			bustoutModal: false,
			openHouseModal: false,
			arcModal: false,
			viewApproved: false,
			data: {},
			user: currentUser(),
			options: {
				responsive: true,
				maintainAspectRatio: false, // leave this as false, see builder dashboard as an example.
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								userCallback: function (label, index, labels) {
									// when the floored value is the same as the value we have a whole number
									if (Math.floor(label) === label) {
										return label
									}
								},
							},
						},
					],
				},
				plugins: {
					datalabels: { display: false },
				},
			},
		}
	}

	trafficTotal = () => {
		let c = 0
		//console.log(this.state.user.id)
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			if (v.salesperson == this.state.user.id) {
				c++
			}
		})
		_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
			//console.log(v.user)
			if (v.user == this.state.user.id) {
				c += v.prospect_count
				c += v.realtor_count
			}
		})
		return c
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	buttonClick = (modal, data) => {
		this.setState({
			[modal]: true,
			data,
		})
	}

	checklist = () => {
		if (settings.builderPortalOnlyMarketing) return ""
		let columns = [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Actions",
				accessor: "actions",
				className: "actions",
				filterable: false,
				minWidth: 250,
			},
		]
		let data = []
		let twoWeeks = moment().subtract(2, "weeks").unix()
		_.forEach(this.props.payload?.salespersonPayload?.lots?.current, (r) => {
			let start, complete, estimatedClosing, contractActions, profile
			let requirePaperworkBeforeClosing = settings.requirePaperworkBeforeClosing
			let hasPressing = false
			let needPaperwork = false
			let closing
			let property = _.find(this.props.payload.public.properties, { id: r.property })
			if (r.sale_id && property.no_paperwork !== 1 && r.sale_date < twoWeeks) {
				_.forEach(r.documents, (v) => {
					if (["rejected", "awaiting"].includes(v.status)) {
						needPaperwork = true
					}
				})
				if (!r.documents) {
					needPaperwork = true
				}
				if (needPaperwork) {
					hasPressing = true
					profile = (
						<button className={`btn btn--attention`} onClick={() => this.buttonClick("buyerModal", r)}>
							Buyer Paperwork
						</button>
					)
				}
			}
			if (r.lot_status == "Contract" && r.estimated_closing < twoWeeks) {
				hasPressing = true
				estimatedClosing = (
					<button className={`btn btn--attention`} onClick={() => this.buttonClick("estimatedModal", r)}>
						Edit Estimated Closing
					</button>
				)
				if (r.sale_date && !r.closing_date) {
					closing = (
						<button className="btn" onClick={() => this.buttonClick("closingModal", r)}>
							Add Closing
						</button>
					)
					if (requirePaperworkBeforeClosing && needPaperwork) closing = null
				}
				contractActions = (
					<span>
						<button className="btn" onClick={() => this.buttonClick("bustoutModal", r)}>
							Cancel Contract
						</button>
						<button className="btn" onClick={() => this.buttonClick("transferModal", r)}>
							Transfer Lot
						</button>
						{closing}
					</span>
				)
			}
			if (!r.start_date && r.missing_start && !settings?.disableBuilderConstructionStatus) {
				hasPressing = true
				start = (
					<button className={"btn btn--attention"} onClick={() => this.buttonClick("startModal", r)}>
						Add Start
					</button>
				)
			}
			if (r.start_date && !r.complete_date && r.missing_complete && !settings?.disableBuilderConstructionStatus) {
				hasPressing = true
				complete = (
					<button className={"btn btn--attention"} onClick={() => this.buttonClick("completeModal", r)}>
						Add Complete
					</button>
				)
			}
			if (!hasPressing) return
			let actions = (
				<div>
					{start}
					{complete}
					{estimatedClosing}
					{contractActions}
					{profile}
				</div>
			)
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			data.push({
				community: property.name || "",
				builder: builder.name || "",
				address: r.address,
				actions,
			})
		})

		if (data.length == 0) return ""
		return (
			<>
				<h2 className="pt-0">
					<i className="fa-duotone fa-file-exclamation text-red-500 mr-2"></i> Pressing Data Checklist
				</h2>
				<FullTable
					data={data}
					columns={columns}
					name="entryDashboard__pressing"
					title="Pressing Data Checklist"
					classNames={"small"}
				/>
			</>
		)
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			let chartData = {
				sales: {
					labels: Object.keys(this.props.payload.sales.currentChart),
					datasets: [
						{
							fill: false,
							data: Object.values(this.props.payload.sales.currentChart),
						},
					],
				},
				closings: {
					labels: Object.keys(this.props.payload.closings.currentChart),
					datasets: [
						{
							fill: false,
							data: Object.values(this.props.payload.closings.currentChart),
						},
					],
				},
				bustouts: {
					labels: Object.keys(this.props.payload.bustouts.currentChart),
					datasets: [
						{
							fill: false,
							data: Object.values(this.props.payload.bustouts.currentChart),
						},
					],
				},
				traffic: {
					labels: Object.keys(this.props.payload.traffic.currentChart),
					datasets: [
						{
							fill: false,
							data: Object.values(this.props.payload.traffic.currentChart),
						},
					],
				},
			}
			return (
				<div className="entryDashboard">
					<div className="imageGroup">
						<Title title="Dashboard" />
						{!settings?.builderPortalMarketingAndARC && (
							<div className="content">
								<PressingTable mode="salesperson" buttonClick={this.buttonClick} />
							</div>
						)}
						<div className="twoCol content">
							<div className="twoCol__col">
								<div className="chartBlock">
									<h3>Sales</h3>
									<p className="chartBlock__title">Total</p>
									<p className="chartBlock__dataTitle">{this.props.payload.sales.current.length}</p>
									<div className="chartContain">
										<Line options={this.state.options} data={chartData.sales} />
									</div>
								</div>
							</div>
							<div className="twoCol__col">
								<h3>Closings</h3>
								<p className="chartBlock__title">Total</p>
								<p className="chartBlock__dataTitle">{this.props.payload.closings.current.length}</p>
								<div className="chartContain">
									<Line options={this.state.options} data={chartData.closings} />
								</div>
							</div>
						</div>
						<div className="twoCol content">
							<div className="twoCol__col">
								<div className="chartBlock">
									<h3>Cancels</h3>
									<p className="chartBlock__title">Total</p>
									<p className="chartBlock__dataTitle">
										{this.props.payload.bustouts.current.length}
									</p>
									<div className="chartContain">
										<Line options={this.state.options} data={chartData.bustouts} />
									</div>
								</div>
							</div>
							<div className="twoCol__col">
								<h3>Traffic</h3>
								<p className="chartBlock__title">Total</p>
								<p className="chartBlock__dataTitle">{this.trafficTotal()}</p>
								<div className="chartContain">
									<Line options={this.state.options} data={chartData.traffic} />
								</div>
							</div>
						</div>
					</div>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.bustoutModal}
						onClose={() => this.setState({ bustoutModal: false })}
						center>
						<BustoutModal data={this.state.data} notify={this.notify} name="bustoutModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.transferModal}
						onClose={() => this.setState({ transferModal: false })}
						center>
						<TransferModal data={this.state.data} notify={this.notify} name="transferModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.closingModal}
						onClose={() => this.setState({ closingModal: false })}
						center>
						<ClosingModal data={this.state.data} notify={this.notify} name="closingModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.contractModal}
						onClose={() => this.setState({ contractModal: false })}
						center>
						<ContractModal data={this.state.data} notify={this.notify} name="contractModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.startModal}
						onClose={() => this.setState({ startModal: false })}
						center>
						<StartModal data={this.state.data} notify={this.notify} name="startModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.completeModal}
						onClose={() => this.setState({ completeModal: false })}
						center>
						<CompleteModal data={this.state.data} notify={this.notify} name="completeModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.estimatedModal}
						onClose={() => this.setState({ estimatedModal: false })}
						center>
						<EstimatedModal data={this.state.data} notify={this.notify} name="estimatedModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.buyerModal}
						onClose={() => this.setState({ buyerModal: false })}
						center>
						<BuyerModal data={this.state.data} notify={this.notify} name="buyerModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.arcModal}
						onClose={() => this.setState({ arcModal: false })}
						center>
						<ArcModal data={this.state.data} notify={this.notify} name="arcModal" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.viewApproved}
						onClose={() => this.setState({ viewApproved: false })}
						center>
						<ArcViewApprovedLot data={this.state.data} notify={this.notify} name="viewApproved" />
					</Modal>
					<Modal
						classNames={{ modal: "modal" }}
						open={this.state.openHouseModal}
						onClose={() => this.setState({ openHouseModal: false })}
						center>
						<OpenHouse data={this.state.data} notify={this.notify} name="openHouse" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.lotReservationModal}
						onClose={() => this.setState({ lotReservationModal: false })}
						center>
						<LotReservationModal data={this.state.data} notify={this.notify} name="lotReservation" />
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.websiteInfoModal}
						onClose={() => this.setState({ websiteInfoModal: false })}
						center>
						<WebsiteInfoBuilders data={this.state.data} notify={this.notify} name="websiteInfoBuilders" />
					</Modal>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		currentDates: state.currentDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Dashboard)
